// Story 1.18 — TanStack Query hook for GET /api/v1/wallet/refundable-topups.
//
// Lists the caller's top-ups that still have refundable balance + are
// within the 14-day PSD2 window. Drives both the conditional
// "Refund a recent top-up →" link on WalletPage AND the list view on
// RefundPage.

import { useQuery } from "@tanstack/react-query";

import { attachRequestIdToScope } from "../../lib/api-client";

export type RefundableTopupItem = {
  ledger_entry_id: string;
  topped_up_at: string;
  original_amount_cents: number;
  refundable_amount_cents: number;
  days_remaining: number;
  card_hint: string;
};

export type RefundWindowOpen = {
  any_open: boolean;
  earliest_closes_at: string | null;
  days_remaining: number;
  in_window_count: number;
};

export type RefundableTopupsResponse = {
  items: RefundableTopupItem[];
  window_open: RefundWindowOpen;
};

async function fetchRefundableTopups(): Promise<RefundableTopupsResponse> {
  const response = await fetch("/api/v1/wallet/refundable-topups", {
    credentials: "include",
  });
  attachRequestIdToScope(response);
  if (!response.ok)
    throw new Error(`refundable-topups fetch failed: ${response.status}`);
  return (await response.json()) as RefundableTopupsResponse;
}

export function useRefundEligibleList() {
  return useQuery({
    queryKey: ["refund-eligible-topups"],
    queryFn: fetchRefundableTopups,
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    retry: false,
  });
}
